import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { DetailsItem as Item } from '@calendly/booking-kit'

import { useI18n } from 'locales'

const PackageSession = ({ currentSession, numSessions, bookingAppRedesign = false }) => {
  const { i18n } = useI18n()

  return currentSession && numSessions && (
    <Item>
      <div>
        <UiIcon
          icon={IconCalendar}
          size={bookingAppRedesign ? 'small' : 'medium'}
          spacingRight="8"
          data-id="details-item-icon"
        />
      </div>
      {i18n.t('booking.package.session_of', { current: currentSession, total: numSessions })}
    </Item>
  )
}

export default PackageSession
